export const footerSales = {
  template: `
  <footer>
    <span class='left'>&copy; Team Onboard Ltd | Company No: 10621176 | <a href='/#/terms'>Terms</a></span>
    <address>Team Onboard | International House, 776-778 Barking Road, London, E13 9PJ</address>
  </footer>`
};